<template>
    <div v-if="loaded && adcount > 0" class="row">
        <div class="col-md-12 text-center">
            <a :href="ads[currentAd].hotelurl" target="_blank" style="position: relative; display: inline-block; margin-bottom: 14px;"><img :src="`/uploads/${ads[currentAd].id}/hotel/${ads[currentAd].hotelad}`" style="max-width: 100%;" /><div class="expl"><router-link :to="{ name: 'settings.hotel' }">This is an ad</router-link></div></a>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Advertisement',

    data: () => ({
        ads: [],
        currentAd: 0,
        adcount: 0,
        loaded: false
    }),

    created: function () {
        this.fetchData();
    },

    watch:{
        $route (to, from){
            this.currentAd = Math.floor(Math.random() * this.adcount);
        }
    },

    methods: {
        fetchData: function () {
            this.loaded = false;
            this.adcount = 0;
            axios.get('/api/getpartners').then(response => {
                this.adcount = Object.keys(response.data).length;
                if(this.adcount > 0) {
                    this.ads = response.data;
                    this.$emit('updateAdCount', this.adcount);
                }
                this.loaded = true;
            });
        },
    }
}
</script>

<style>
.expl {
  position: absolute;
  right: 0;
  bottom: 0;
  text-transform: uppercase;
  font-size: 8px;
  background-color: rgba(200,200,200,0.7);
  color: #404040;
  padding-left: 2px;
  padding-right: 2px;
  border-top-left-radius: 4px;
}

</style>


// WEBPACK FOOTER //
// resources/js/components/Advertisement.vue